@use 'src/global/mixins/icon' as icon;
@use 'src/global/variables' as var;

c-input-text {
  position: absolute;
  width: 100%;
  bottom: 0;
  &.is-disabled {
    cursor: not-allowed;
    background-color: #efefef;
    form {
      input,
      button {
        background-color: #efefef;
        cursor: not-allowed;
      }
    }
  }

  .info-message {
    z-index: 9999;
    background-color: var.$color-slate-grey;
    margin-top: -25px;
    height: 25px;

    p {
      color: white;
      font-size: 0.8rem;
      margin: 0;
      position: absolute;
      top: -20%;
      transform: translate(0, -50%);
      padding-left: 1rem;
    }
  }

  // This is needed for Safari, where the IE background-color fix color from ba-chatbot-component.scss
  // shines through around the edges of the input.
  border-radius: 0 0 8px 8px;
  form {
    background-color: var.$text-color-light;
    display: flex;
    border-radius: 0 0 8px 8px;
    input {
      border-radius: 0 0 0 8px;
      // 1px less than smallest iPad
      @media screen and (max-width: 767px) {
        border-radius: 0;
      }
      color: var.$primary-color;
      box-sizing: border-box;
      padding: 1.3rem 1rem;
      font-size: 16px; // To prevent auto zoom in on iPhones, we need font-size >= 16px
      width: 100%;
      border: none;
      &::placeholder {
        color: var.$color-slate-grey;
      }
      &:focus {
        z-index: 1;
        outline: none;
        box-shadow: inset 0 0 0 3px var.$focus-color;
      }
    }
    button {
      border-radius: 0 0 8px 0;
      // 1px less than smallest iPad
      @media screen and (max-width: 767px) {
        border-radius: 0;
      }
      padding: 0 1rem;
      background-color: var.$text-color-light; // Needed on mobile
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center; // To center icon if font-size of body gets decreased a lot
      &:focus {
        z-index: 1;
        outline: none;
        box-shadow: inset 0 0 0 3px var.$focus-color;
      }
      i:before {
        font-size: x-large;
        @include icon.icon;
        color: var.$text-color-medium;
        content: '\f119';
      }
    }
  }
}
